/**
 * 사용자 영역(/app) 보고서의 브랜드 — **주소가 정한다**(`/app/report?brand=<brandId>`, 운영자 결정 2026-10-13).
 * 주소를 공유하면 같은 브랜드 보고서가 열린다. 기사 검토·구독 관리는 브랜드를 고르지 않는다(모든 브랜드를 보인다).
 *
 * - 목록은 「내 브랜드」 계약(`/api/account/brands`)이다 — 이름·상태가 함께 온다. 승인 대기(pending)는 뺀다(볼 것이 없다)
 * - 주소의 브랜드가 목록에 없으면(다른 사람 브랜드·지운 브랜드·빈 값) **승인된 첫 브랜드**, 그것도 없으면 첫 브랜드
 * - 결제 대기(confirmed) 브랜드도 고를 수 있다 — 보고서 자리에 「구독을 시작하면 열립니다」를 보인다
 */
import { brand } from '@geo-admin/shared/contract/api/index.ts';
import type { BrandStatus } from '@geo-admin/shared/contract/brand-status.ts';
import { useApi } from './api.ts';

export interface AppBrand {
  brandId: string;
  brandName: string;
  status: BrandStatus;
}

export function useAppBrand(
  wanted: string | undefined,
  enabled = true,
): { brands: AppBrand[]; pending: AppBrand[]; current: AppBrand | null; loading: boolean } {
  const q = useApi(brand.listMyBrands, {}, { enabled });
  const all = (q.data?.brands ?? []).map((b) => ({ brandId: b.id, brandName: b.name, status: b.status }));
  const brands = all.filter((b) => b.status !== 'pending');
  /** 승인 대기 — 고르지 않는다(볼 것이 없다). 보고서의 빈 화면이 이름을 보인다 */
  const pending = all.filter((b) => b.status === 'pending');
  const current =
    brands.find((b) => b.brandId === wanted) ?? brands.find((b) => b.status === 'active') ?? brands[0] ?? null;
  return { brands, pending, current, loading: q.isLoading };
}

/** 주소의 `brand` — uuid 모양만 받는다(나머지는 버린다) */
export function validateReportSearch(search: Record<string, unknown>): { brand?: string } {
  const b = typeof search.brand === 'string' ? search.brand : '';
  return /^[0-9a-f-]{36}$/i.test(b) ? { brand: b } : {};
}
